import React from 'react'
import { type DownloadFile } from '../models/types'
import { fetchLogin } from '../../common/js/bfx-customer-utility';
import Cookies from 'js-cookie';
import { sendHsEvent } from '../../bfxd/js/hubspot-tracking';
import { axiosPost } from '../../common/js/axios-utility';
import { useTranslation } from 'react-i18next'
import MoreOptionsMenu from '../../common/components/MoreOptionsMenu';
import { type ActionMenuItem } from '../../common/types/common.types';
 
type Props = {
    download: DownloadFile
}

export default function DownloadTableItem({ download }: Props) {
    const {t} = useTranslation(['downloads', 'common']);

    const handleDownload = async () => {
        const login = fetchLogin();
        if (!login) {
            Cookies.set('redirect_url', window.location.href);
            window.location.href = '/account/login?source=download';
            return;
        }
        recordHsDownload();
        
        var uri = download.download_url;
        const payload = {
            email: login.email,
            product: download.download_url,
            platform: download.platform,
            version: download.display_version,
            permalink: download.permalink
        }
        
        try{
            await axiosPost('/track', payload);
        }
        catch(e){
            console.error(e);
        }
        window.location.href = uri;
    };

    const recordHsDownload = () => {
        try{
            const properties = {
                product: download.product_line,
                host: download.host,
                platform: download.platform,
                hs_file_url: download.download_url
            }
            sendHsEvent('pe21305637_customerdownloadevent', properties);
        }
        catch(e){
            console.error(e);
        }
    }

    const openReleaseNotes = () => {
        window.open(download.release_notes, '_blank');
    }

    const openMoreInfo = () => {
        window.open(download.permalink, '_blank');
    }

    const menuOptions: ActionMenuItem[] = [
        {
            label: t('actions.download', {ns: 'common'}),
            action: handleDownload
        },
        {
            label: t('releaseNotes'),
            action: openReleaseNotes
        },
        {
            label: t('moreInfo'),
            action: openMoreInfo
        }
    ]

    return (
        <tr>
            <td>{download.product}</td>
            <td>{download.host}</td>
            <td>{download.display_version}</td>
            <td>{download.platform}</td>
            <td>
                <MoreOptionsMenu items={menuOptions} />
            </td>
        </tr>
    )
}